export const textBlack: string = '#444444';
export const buttonBackground: string = '#ffffff';
export const buttonBorder: string = '#444444';
